//document.querySelector('form').addEventListener('submit', function(event) {
//    if (dateField && !dateField.value) {
//    var dateField = document.getElementById('challenge-date');
//        alert('Please select a challenge date.');
//        event.preventDefault();
//    }
//});

document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('form[action="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function(event) {
      const dateField = document.getElementById('challenge-date');
      if (dateField && !dateField.value) {
        event.preventDefault(); // Prevent form submission
        alert('Please select a challenge date before adding the item to your cart.'); // Alert message
        dateField.focus(); // Focus on the date picker field
      }
    });
  }
});
